    /* Sandelfe – Sternenanimation */
    (function () {
      "use strict";

      var intro = document.getElementById("se-intro");
      var layer = document.getElementById("se-magic-layer");
      var origin = document.getElementById("se-magic-origin");
      var page = document.querySelector(".se-birthday");
      var phoneLink = document.querySelector('a[href="tel:+4933795926862"]');
      var elfImage = intro ? intro.querySelector(".se-elf") : null;
      var firstInfoItem = intro
        ? intro.querySelector(".se-intro-list li:first-child")
        : null;

      if (!intro || !layer || !origin || !page) return;

      var played = false;
      var scrollStopTimer = null;
      var userHasScrolled = false;
      var pageReadyAt = performance.now() + 600;
      var reducedMotion =
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      function rand(min, max) {
        return min + Math.random() * (max - min);
      }

      function clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
      }

      function shuffle(values) {
        for (var i = values.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = values[i];
          values[i] = values[j];
          values[j] = tmp;
        }
        return values;
      }

      /*
        Lange, sanfte Schwebekurve über die Seitenbreite:

        - zunächst deutlich nach rechts und nur leicht nach oben,
        - der Bogen zieht sich weit über die Seite,
        - einige Sterne verlieren früher Auftrieb, andere erst weit hinten,
        - der Übergang ins Sinken ist überall weich,
        - keine Wand, kein Knick und kein gemeinsamer Absturzpunkt.
      */
      function makePath(
        targetX,
        endY,
        liftHeight,
        liftPeak,
        fallPower,
        pointCount
      ) {
        var points = [];

        /*
          Die Auftriebskurve ist eine glatte Beta-Kurve.
          Sie beginnt und endet ohne sichtbaren Knick.
        */
        var liftA = 1.35;
        var liftB =
          liftA * (1 - liftPeak) / liftPeak;

        var peakValue =
          Math.pow(liftPeak, liftA) *
          Math.pow(1 - liftPeak, liftB);

        for (var i = 0; i < pointCount; i++) {
          var t = i / (pointCount - 1);

          /*
            Durchgehende Rechtsbewegung bis zum Schluss.
            Anfang etwas kräftiger, danach gleichmäßig weiter.
          */
          var xProgress =
            0.82 * t +
            0.18 * (1 - Math.pow(1 - t, 2.0));

          /*
            Breiter, langer Auftriebsbogen.
            Der Gipfel liegt je Stern an einer anderen Stelle.
          */
          var liftShape =
            Math.pow(t, liftA) *
            Math.pow(1 - t, liftB);

          var lift =
            -liftHeight *
            (liftShape / Math.max(0.000001, peakValue));

          /*
            Der Fallanteil wächst von Anfang an minimal und danach
            kontinuierlich. Unterschiedliche fallPower-Werte sorgen dafür,
            dass manche Sterne früher und andere erst weit hinten sinken.
          */
          var fall =
            endY * Math.pow(t, fallPower);

          points.push({
            x: targetX * xProgress,
            y: lift + fall
          });
        }

        return points;
      }

      /*
        Gleichmäßiges Tempo entlang der gesamten Kurve.
      */
      function resampleByDistance(points, frameCount) {
        var cumulative = [0];
        var total = 0;

        for (var i = 1; i < points.length; i++) {
          var dx = points[i].x - points[i - 1].x;
          var dy = points[i].y - points[i - 1].y;
          total += Math.sqrt(dx * dx + dy * dy);
          cumulative.push(total);
        }

        var result = [];

        for (var frame = 0; frame < frameCount; frame++) {
          var wanted = total * frame / (frameCount - 1);
          var segment = 1;

          while (
            segment < cumulative.length - 1 &&
            cumulative[segment] < wanted
          ) {
            segment++;
          }

          var beforeDistance = cumulative[segment - 1];
          var afterDistance = cumulative[segment];
          var span = Math.max(0.0001, afterDistance - beforeDistance);
          var local = (wanted - beforeDistance) / span;

          var before = points[segment - 1];
          var after = points[segment];

          result.push({
            x: before.x + (after.x - before.x) * local,
            y: before.y + (after.y - before.y) * local,
            totalDistance: total
          });
        }

        return result;
      }

      function launchStars() {
        if (played) return;
        played = true;

        var pageRect = page.getBoundingClientRect();
        var originRect = origin.getBoundingClientRect();

        var startX =
          originRect.left - pageRect.left + originRect.width / 2;
        var startY =
          originRect.top - pageRect.top + originRect.height / 2;

        var phoneY;

        if (phoneLink) {
          var phoneRect = phoneLink.getBoundingClientRect();
          phoneY =
            phoneRect.top - pageRect.top + phoneRect.height / 2;
        } else {
          phoneY = page.scrollHeight - 70;
        }

        layer.style.height = page.scrollHeight + "px";

        var count = reducedMotion ? 24 : 40;
        var pageWidth = page.clientWidth;
        var usableRight = Math.max(120, pageWidth - startX - 10);

        /*
          Breite Verteilung:
          fast alle Sterne fliegen deutlich über die Sandelfe hinaus.
          Einige enden früher, viele erreichen fast den rechten Seitenrand.
        */
        var lanes = [];

        for (var laneIndex = 0; laneIndex < count; laneIndex++) {
          var lane =
            0.52 +
            0.48 * laneIndex / Math.max(1, count - 1) +
            rand(-0.012, 0.012);

          lanes.push(clamp(lane, 0.50, 0.998));
        }

        shuffle(lanes);

        for (var i = 0; i < count; i++) {
          (function (index, laneFraction) {
            var delay = index === 0
              ? 0
              : Math.max(
                  0,
                  index / Math.max(1, count - 1) * 3200 +
                  rand(-70, 70)
                );

            window.setTimeout(function () {
              var star = document.createElement("span");
              star.className = "se-star";
              star.textContent = Math.random() < 0.80 ? "★" : "✦";

              star.style.fontSize =
                rand(4.2, 9.0).toFixed(1) + "px";
              star.style.left =
                (startX + rand(-2.5, 3.5)).toFixed(1) + "px";
              star.style.top =
                (startY + rand(-2.0, 2.0)).toFixed(1) + "px";

              layer.appendChild(star);

              var targetX =
                Math.max(
                  pageWidth * 0.42,
                  usableRight * laneFraction
                );

              /*
                Kein steiler Aufstieg:
                Der Bogen ist länger und flacher und zieht sich über die Seite.
              */
              var liftHeight =
                pageWidth >= 760
                  ? rand(95, 145)
                  : rand(58, 92);

              /*
                Einige Sterne erreichen ihren höchsten Punkt früher,
                andere erst deutlich weiter hinten.
              */
              var liftPeak =
                pageWidth >= 760
                  ? rand(0.30, 0.58)
                  : rand(0.26, 0.50);

              /*
                Kleine Werte sinken etwas früher,
                große Werte erst weit hinten.
                Alles bleibt eine einzige glatte Kurve.
              */
              var fallPower =
                rand(2.15, 4.10);

              var endY = Math.max(
                760,
                phoneY - startY - rand(25, 90)
              );

              var rawPath = makePath(
                targetX,
                endY,
                liftHeight,
                liftPeak,
                fallPower,
                700
              );

              /*
                Viele Zwischenbilder verhindern sichtbare Sprünge.
              */
              var path = resampleByDistance(rawPath, 280);
              var pathLength =
                path[path.length - 1].totalDistance;

              /*
                Tempo exakt unverändert.
              */
              var speed = reducedMotion
                ? rand(55, 63)
                : rand(43, 51);

              var duration =
                pathLength / speed * 1000;

              var keyframes = path.map(function (point, frameIndex) {
                var progress =
                  frameIndex / (path.length - 1);

                var opacity;

                if (progress < 0.025) {
                  opacity = progress / 0.025;
                } else if (progress < 0.91) {
                  opacity = 0.96 - progress * 0.11;
                } else {
                  opacity = Math.max(
                    0,
                    (1 - progress) / 0.09 * 0.86
                  );
                }

                return {
                  opacity: opacity,
                  transform:
                    "translate3d(" +
                    point.x.toFixed(2) + "px," +
                    point.y.toFixed(2) + "px,0) " +
                    "scale(" +
                    (1 - progress * 0.18).toFixed(3) +
                    ")",
                  offset: progress
                };
              });

              var animation = star.animate(
                keyframes,
                {
                  duration: duration,
                  easing: "linear",
                  fill: "forwards"
                }
              );

              animation.onfinish = function () {
                star.remove();
              };
            }, delay);
          })(i, lanes[i]);
        }
      }

      function imageIsLoadedAndVisible() {
        if (!elfImage) return false;

        if (
          !elfImage.complete ||
          elfImage.naturalWidth <= 0 ||
          elfImage.naturalHeight <= 0
        ) {
          return false;
        }

        var rect = elfImage.getBoundingClientRect();

        if (rect.width < 20 || rect.height < 20) {
          return false;
        }

        /*
          Die gesamte Sandelfe muss sichtbar sein.
        */
        return (
          rect.top >= -1 &&
          rect.left >= -1 &&
          rect.bottom <= window.innerHeight + 1 &&
          rect.right <= window.innerWidth + 1
        );
      }

      function firstInfoLineIsInReadingZone() {
        if (!firstInfoItem) return false;

        var rect = firstInfoItem.getBoundingClientRect();
        var centerY = rect.top + rect.height / 2;

        /*
          „Für Kinder ab der 1. Klasse“ muss nicht nur irgendwo am
          unteren Rand auftauchen, sondern bereits in der normalen
          Lesezone des Displays stehen.
        */
        return (
          rect.top >= 0 &&
          rect.bottom <= window.innerHeight &&
          centerY >= window.innerHeight * 0.28 &&
          centerY <= window.innerHeight * 0.66
        );
      }

      function triggerPositionIsRight() {
        return (
          imageIsLoadedAndVisible() &&
          firstInfoLineIsInReadingZone()
        );
      }

      function cancelPendingStart() {
        if (scrollStopTimer !== null) {
          window.clearTimeout(scrollStopTimer);
          scrollStopTimer = null;
        }
      }

      function stopWatching() {
        cancelPendingStart();

        window.removeEventListener("scroll", onScroll);
        window.removeEventListener("resize", onResize);
        window.removeEventListener("pageshow", onPageShow);

        if (elfImage) {
          elfImage.removeEventListener("load", checkAfterScrollingStops);
        }
      }

      function checkAfterScrollingStops() {
        if (played || !userHasScrolled) return;

        cancelPendingStart();

        /*
          Nicht während des Scrollens starten. Erst wenn 400 ms lang
          nicht mehr gescrollt wurde, wird die Position geprüft.
        */
        scrollStopTimer = window.setTimeout(function () {
          scrollStopTimer = null;

          if (!played && triggerPositionIsRight()) {
            launchStars();
            stopWatching();
          }
        }, 400);
      }

      function onScroll() {
        /*
          Frühe automatische Layout- oder Scrollkorrekturen des Browsers
          gelten nicht als bewusstes Herunterscrollen.
        */
        if (performance.now() >= pageReadyAt) {
          userHasScrolled = true;
        }

        checkAfterScrollingStops();
      }

      function onResize() {
        cancelPendingStart();

        if (userHasScrolled) {
          checkAfterScrollingStops();
        }
      }

      function onPageShow() {
        cancelPendingStart();
      }

      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      window.addEventListener("resize", onResize);
      window.addEventListener("pageshow", onPageShow);

      if (elfImage) {
        elfImage.addEventListener("load", checkAfterScrollingStops);
      }

    })();

    /* Sandelfe – Preisrechner */
    (function () {
      "use strict";

      var BASE_PRICE = 185;
      var PRICES = {
        extraSmall: 4.5,
        extraLarge: 6.5,
        framelessSmall: 4.5,
        plasticSmall: 5,
        framelessLarge: 6.5,
        plasticLarge: 7.5,
        bracelets: 2.5
      };

      var calculator = document.getElementById("se-calculator");
      if (!calculator) return;

      /*
        Das alte Supply-Theme formatiert input[type="number"] teilweise selbst
        und fügt zusätzliche Trennstriche sowie Plus-/Minus-Elemente ein.
        Deshalb werden alle Mengenfelder hier sauber neu aufgebaut und als
        normale Textfelder mit numerischer Bildschirmtastatur ausgegeben.
      */
      calculator.querySelectorAll(".se-quantity").forEach(function (wrapper) {
        var oldField = wrapper.querySelector("input");
        if (!oldField) return;

        var attributes = {
          id: oldField.id,
          ariaLabel: oldField.getAttribute("aria-label") || "Menge",
          min: oldField.getAttribute("min") || "0",
          max: oldField.getAttribute("max") || "999",
          value: oldField.value || "0"
        };

        var minus = document.createElement("button");
        minus.type = "button";
        minus.className = "se-minus";
        minus.setAttribute("aria-label", "Verringern");
        minus.textContent = "−";

        var field = document.createElement("input");
        field.type = "text";
        field.id = attributes.id;
        field.value = attributes.value;
        field.setAttribute("aria-label", attributes.ariaLabel);
        field.setAttribute("min", attributes.min);
        field.setAttribute("max", attributes.max);
        field.setAttribute("inputmode", "numeric");
        field.setAttribute("pattern", "[0-9]*");
        field.setAttribute("autocomplete", "off");

        var plus = document.createElement("button");
        plus.type = "button";
        plus.className = "se-plus";
        plus.setAttribute("aria-label", "Erhöhen");
        plus.textContent = "+";

        wrapper.replaceChildren(minus, field, plus);
      });

      var childrenField = document.getElementById("se-children");
      var message = document.getElementById("se-message");
      var messageText = document.getElementById("se-message-text");
      var messageTotal = document.getElementById("se-message-total");
      var result = document.getElementById("se-result");

      function quantity(id) {
        var field = document.getElementById(id);
        var value = parseInt(field.value, 10);
        return Number.isFinite(value) && value >= 0 ? value : 0;
      }

      function selected(name) {
        return calculator.querySelector('input[name="' + name + '"]:checked');
      }

      function money(value) {
        var locale = document.documentElement.lang || "de-DE";
        return value.toLocaleString(locale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + " €";
      }

      function showRow(id, visible) {
        var row = document.getElementById(id);
        if (row) row.style.display = visible ? "flex" : "none";
      }

      function calculate() {
        var childCount = parseInt(childrenField.value, 10);
        var dateChoice = selected("se-date");
        var packageChoice = selected("se-package");
        var timeChoice = selected("se-time");

        if (!Number.isFinite(childCount) || !dateChoice || !packageChoice) {
          if (messageText) {
            messageText.textContent =
              "Bitte Kinderzahl, Veranstaltungstag und Bildvariante wählen.";
            messageText.style.display = "block";
          }
          if (messageTotal) {
            messageTotal.innerHTML = "<strong>Gesamtpreis: –</strong>";
          }
          message.style.display = "block";
          result.style.display = "none";
          return;
        }

        var surcharge = parseFloat(dateChoice.value);
        var packageTotal = childCount * parseFloat(packageChoice.value);

        var extrasTotal =
          quantity("se-extra-small") * PRICES.extraSmall +
          quantity("se-extra-large") * PRICES.extraLarge;

        var framesTotal =
          quantity("se-frameless-small") * PRICES.framelessSmall +
          quantity("se-plastic-small") * PRICES.plasticSmall +
          quantity("se-frameless-large") * PRICES.framelessLarge +
          quantity("se-plastic-large") * PRICES.plasticLarge;

        var braceletsTotal = quantity("se-bracelets") * PRICES.bracelets;
        var timeTotal = timeChoice ? parseFloat(timeChoice.value) : 0;

        var total =
          BASE_PRICE +
          surcharge +
          packageTotal +
          extrasTotal +
          framesTotal +
          braceletsTotal +
          timeTotal;

        document.getElementById("se-result-base").textContent = money(BASE_PRICE);
        document.getElementById("se-result-surcharge").textContent = money(surcharge);
        document.getElementById("se-result-package").textContent = money(packageTotal);
        document.getElementById("se-result-extras").textContent = money(extrasTotal);
        document.getElementById("se-result-frames").textContent = money(framesTotal);
        document.getElementById("se-result-bracelets").textContent = money(braceletsTotal);
        document.getElementById("se-result-time").textContent = money(timeTotal);

        showRow("se-row-surcharge", surcharge > 0);
        showRow("se-row-extras", extrasTotal > 0);
        showRow("se-row-frames", framesTotal > 0);
        showRow("se-row-bracelets", braceletsTotal > 0);
        showRow("se-row-time", timeTotal > 0);

        if (messageText) {
          messageText.style.display = "none";
        }
        if (messageTotal) {
          messageTotal.innerHTML =
            "<strong>Gesamtpreis: " + money(total) + "</strong>";
        }
        message.style.display = "block";
        result.style.display = "block";
      }

      calculator.querySelectorAll(".se-plus, .se-minus").forEach(function (button) {
        button.addEventListener("click", function () {
          var wrapper = button.closest(".se-quantity");
          var field = wrapper.querySelector("input");
          var value = parseInt(field.value, 10);

          if (!Number.isFinite(value)) value = 0;

          var minimum = parseInt(field.min || "0", 10);
          var maximum = parseInt(field.max || "999", 10);

          if (button.classList.contains("se-plus")) {
            value = Math.min(maximum, value + 1);
          } else {
            value = Math.max(minimum, value - 1);
          }

          field.value = value;
          calculate();
        });
      });

      calculator.querySelectorAll(".se-quantity input").forEach(function (field) {
        field.addEventListener("input", function () {
          var cleaned = field.value.replace(/[^0-9]/g, "");
          var minimum = parseInt(field.getAttribute("min") || "0", 10);
          var maximum = parseInt(field.getAttribute("max") || "999", 10);

          if (cleaned === "") {
            field.value = "";
            return;
          }

          var value = parseInt(cleaned, 10);
          if (!Number.isFinite(value)) value = minimum;
          field.value = Math.max(minimum, Math.min(maximum, value));
        });

        field.addEventListener("blur", function () {
          if (field.value === "") field.value = field.getAttribute("min") || "0";
          calculate();
        });
      });

      calculator.querySelectorAll("input, select").forEach(function (field) {
        field.addEventListener("change", calculate);
        field.addEventListener("input", calculate);
      });

      calculate();
    })();





    /* SANDELFE – AUTOMATISCHE VIDEOFORMAT-ERKENNUNG + VOLLBILD */
    (function () {
      "use strict";

      function initialiseSandelfeVideos() {
        var videos = document.querySelectorAll(
          ".se-birthday .se-video-wrap video, " +
          ".se-birthday .se-video-wrap-top video, " +
          ".se-birthday .se-video-wrap-secondary video"
        );

        videos.forEach(function (video, index) {
          var wrapper = video.parentElement;
          if (!wrapper) return;

          function applyNaturalRatio() {
            if (!video.videoWidth || !video.videoHeight) return;

            wrapper.style.setProperty(
              "--se-video-ratio",
              video.videoWidth + " / " + video.videoHeight
            );
            wrapper.classList.add("se-video-ratio-ready");
          }

          if (video.readyState >= 1) {
            applyNaturalRatio();
          } else {
            video.addEventListener("loadedmetadata", applyNaturalRatio, { once: true });
          }

          if (!wrapper.nextElementSibling ||
              !wrapper.nextElementSibling.classList.contains("se-video-fullscreen-row")) {
            var row = document.createElement("div");
            row.className = "se-video-fullscreen-row";

            var button = document.createElement("button");
            button.type = "button";
            button.className = "se-video-fullscreen-button";
            button.textContent = "⛶ Video vergrößern";
            button.setAttribute(
              "aria-label",
              index === 0 ? "Erstes Video im Vollbild öffnen" : "Video im Vollbild öffnen"
            );

            button.addEventListener("click", function () {
              if (video.requestFullscreen) {
                video.requestFullscreen();
              } else if (video.webkitEnterFullscreen) {
                video.webkitEnterFullscreen();
              } else if (video.webkitRequestFullscreen) {
                video.webkitRequestFullscreen();
              } else {
                video.play();
              }
            });

            row.appendChild(button);
            wrapper.insertAdjacentElement("afterend", row);
          }
        });
      }

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initialiseSandelfeVideos);
      } else {
        initialiseSandelfeVideos();
      }
    })();
